import { TracLinkState } from './state';

export const tracLinkInitialState: TracLinkState = {
  tourEvents: [],
  tourEventsError: null,
  tourEventDrafts: {
    new: [],
    edit: {},
  },
};
